import type React from 'react';
import { useApp } from '@/forApp/states/appState/appState';
import Tabs, { type TabItem } from '@/shared/Tabs/Tabs';

interface PropertyTypeFilterDesktopProps {
  onChange?: (value: string) => void;
  isMobile?: boolean;
}

const entityTypes: TabItem[] = [
  { title: 'Квартиры', value: 'apartments' },
  { title: 'Новостройки', value: 'new-buildings' },
  { title: 'Дома и участки', value: 'houses' },
  { title: 'Гаражи', value: 'garages' },
  { title: 'Коммерческая', value: 'commercial' },
];

export const SelectEntityType: React.FC<PropertyTypeFilterDesktopProps> = ({
  onChange,
  isMobile,
}) => {
  const { filters, setFilters, cleanFilters } = useApp();

  const handleEntityTypeChange = (value: string) => {
    setFilters('type', value);
    cleanFilters();
    if (onChange) onChange(value);
  };

  return (
    <Tabs
      tabs={entityTypes}
      activeTab={filters.type as string}
      onTabChange={handleEntityTypeChange}
      variant="entity-selector"
      isMobile={isMobile}
    />
  );
};
